import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  border: 1px solid #e6e8f0;
  border-radius: 8px;
  padding: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

interface IShow {
  show?: boolean;
}

export const Show = styled.div<IShow>`
  display: ${({ show }) => (show ? 'block' : 'none')};
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #1b203a;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;

  &.itemHeavy {
    font-size: 14px;
    font-weight: 500;
    color: #474d66;
    text-align: left;
  }

  &.itemLight {
    font-size: 12px;
    font-weight: 400;
    color: #474d66;
    text-align: left;
  }
`;

export const CounterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;
  align-items: center;
`;

export const Counter = styled.div`
  display: flex;
  height: 22px;
  background-color: #edeff4;
  border-radius: 4px;
  padding: 0px 6px;

  font-size: 14px;
  font-weight: 600;
  color: #474d66;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

export const Item = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 6px 8px;
  height: 52px;
  border: 0;
  background-color: transparent;
`;

export const ColumnWrapper = styled.div`
  display: flex;
  margin-left: 8px;
  flex: 1;
  align-items: center;
  height: 100%;
`;

export const RowWrapper = styled.div`
  flex: 1;
`;

export const LineDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid #e6e8f0;
  margin: 4px 0;
`;

interface IFavoriteButton {
  center?: boolean;
}

export const FavoriteButton = styled.div<IFavoriteButton>`
  height: 16px;
  width: 16px;
  cursor: pointer;
  align-self: ${({ center }) => (center ? 'center' : 'flex-start')};
  margin-top: ${({ center }) => (center ? '-5px' : '0')};
`;

export const Chevron = styled.div`
  height: 16px;
  cursor: pointer;
`;

export const Items = styled.div`
  flex: 1;
  margin-top: 24px;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const IconButton = styled.div`
  height: 32px;
  cursor: pointer;
`;
